<!-- 首页 -->
<template>
  <div class="wrap">
    <!-- <transition name="el-zoom-in-top">
			<header_menu v-show="topshow" @loginout="log_out" ></header_menu>
    </transition>-->
    <!-- <transition name="el-zoom-in-left">
			<nav_menu v-show="leftshow"></nav_menu>
    </transition>-->
    <div class="usercog">
      <div class="usercog_title">
        <span style="cursor:pointer;" @click="useropen">
          <i class="iconfont icon-times"></i>
        </span>
      </div>
      <div class="usercog_content">
        <el-row>
          <el-col :span="12">
            <div class="usercog_listbox">
              <label>用户名：</label>
              {{username}}
            </div>
          </el-col>
          <el-col :span="12">
            <div class="usercog_listbox">
              <label>帐号：</label>
              {{userno}}
            </div>
          </el-col>
          <el-col :span="24">
            <div class="usercog_listbox">
              <label>手机号：</label>
              {{mobiphone}}
            </div>
          </el-col>
          <el-col :span="24">
            <div class="usercog_listbox">
              <label>所属机构：</label>
              {{shopname}}
            </div>
          </el-col>
          <el-col :span="12">
            <div class="usercog_listbox">
              <label>网速状态：</label>
              <span v-loading="isture">{{getSpeed}}</span> 
              <!-- <span v-if="!isture" v-loading="">{{getSpeed}}</span> 
              <span v-else style="font-size:12px">加载中..</span> -->
            </div>
          </el-col>
          <el-col :span="12">
            <div class="usercog_listbox">
              <el-button type="text" size="mini" @click="getSpeedBtn" class="mainBtn" :loading="isture">获取网速</el-button>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="usercog_listbox" style="text-align:center;">
              <el-button
                type="primary"
                size="mini"
                @click="XZDialogVisible=true"
                class="mainBtn"
              >切换机构</el-button>
              <el-button type="primary" plain size="mini" @click="outusers" class="mainBtn">注销用户</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="main_box" :class="isactive">
      <div class="bannerbox">
        <div class="usersbox" :class="isactive" @click="useropen">
          <i class="iconfont icon-cog-fill"></i>
        </div>
        <transition name="el-zoom-in-top">
          <img class="bannertitle" v-show="topshow" src="../assets/index_banner_text.png">
        </transition>
        <div class="bannerbtnbox">
          <button class="bannerbtn active" @click="changePo">业务系统</button>
          <button class="bannerbtn" @click="changePo">后台管理</button>
        </div>
      </div>
      <div class="content_box">
        <div class="context_text drumpPosition" id="drumpPosition">
          <div class="context_title">
            <img src="../assets/index_title_1.png">
          </div>
          <div class="context_itembox">
            <div class="itemboxs" v-for="(item, index) in pageData" :key="index" @click="urlgo(item.url,item.stateid,item.id,item.title)">
              <div class="topicon">
                <!--icon-laptop-check-->
                <el-tooltip v-if="item.stateid==1" class="item" effect="dark" content="运行正常" placement="top">
                  <i class="iconfont icon-laptop-check"></i>
                </el-tooltip>

                <el-tooltip v-else class="item" effect="dark" content="关闭运行" placement="top">
                  <i class="iconfont icon-laptop-error"></i>
                </el-tooltip>
              </div>
              <div class="iconbox">
                <i class="iconboxicon iconfont" :class="item.icon"></i>
              </div>
              <div class="itembox_title">{{item.title}}</div>
              <div class="itembox_note">{{item.describe}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <contentbox_ban></contentbox_ban> -->
    <el-dialog
      title="切换管理机构"
      width="500px"
      :visible.sync="XZDialogVisible"
      :append-to-body="true"
      center
    >
      <el-row>
        <el-col :span="24">
          <el-select
            style="width:100%"
            v-model="cpTypeAK_sel"
            filterable
            size="mini"
            placeholder="请选择机构"
          >
            <el-option
              v-for="item in cpTypeAK_return"
              :key="item.agenceid"
              :label="item.shopname"
              :value="item.agenceid"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="qiejigoubtn" size="mini">确 定</el-button>
        <el-button type="primary" @click="XZDialogVisible=false" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import header_menu from "@/components/header";
import nav_menu from "@/components/menu_left";
import contentbox_ban from "@/components/contentbox_ban";
import { networkState, networkSpeed, measureBW } from '../router/speed';
import $ from 'jquery';
export default {
  data() {
    return {
      winh: window.innerHeight - 140,
      topshow: false,
      leftshow: false,
      mainshow: false,
      isCollapse: true,
      dialogTableVisible: false,
      dialogTableVisible_ruku: false,
      staff_url: "http://posstaff.ailend.hk/#/",
      pageData: [],
      ifact: false,
      isactive: "",
      username: "", //姓名
      userno: "", //帐号networkSpeed
      mobiphone: "", //手机号
      agenceid: "", //机构id
      shopname: "", //机构名称
      cpTypeAK_sel: "", //选中的机构
      cpTypeAK_return: [], //机构列表
      XZDialogVisible: false, //切换机构弹层显示
      getSpeed: '', // 获取网速状态
      isture: false
    };
  },

  components: {
    header_menu,
    nav_menu,
    contentbox_ban
  },

  computed: {},
  created: function() {
    let testString = 'abdewl'
    console.log('浏览器', navigator.connection.downlink * 1024 / 8)
    this.$http
      .post(
        API.API_TOKEN + "Pub_PageJurisdiction/GetSystemmeau",
        this.$qs.stringify({
          version: API.VERSION_NUM,
          iphone: localStorage.tnk
        })
      )
      .then(res => {
        console.log(res.data);
        if (res.data.error_code == 0) {
          this.pageData = res.data.data;
        }
      });
  },

  mounted: function() {
    this.getSpeedBtn()
    if (localStorage.tnk) {
      API.IPHONE_TOKEN = localStorage.tnk;
    } else {
      setTimeout(() => {
        this.log_out();
      }, 1000);
    }
    var _this = this;
    setTimeout(() => {
      this.topshow = true;
    }, 300);
    setTimeout(() => {
      this.leftshow = true;
    }, 400);
    setTimeout(() => {
      this.mainshow = true;
    }, 500);

    //获取用户信息
    let postData_code = _this.$qs.stringify({
      version: API.VERSION_NUM,
      iphone: localStorage.tnk,
      sysid:""
    });
    _this.$axios({
        url: API.API_TOKEN + "PublicUser/UserInfoByIphone",
        method: "POST",
        data: postData_code
      })
      .then(res => {
        if (res.data.error_code == 0) {
          this.username = res.data.data[0].username;
          this.userno = res.data.data[0].userno;
          this.mobiphone = res.data.data[0].mobiphone;
          this.agenceid = res.data.data[0].agenceid;
          this.shopname = res.data.data[0].shopname;
        } else if (res.data.error_code == 40001) {
          _this.$message.error("页面过期，请重新登陆！");
          // setTimeout(function() {
          //   window.parent.location.href = "";
          //   window.parent.close();
          // }, 1000);
        } else {
          _this.$message.error("获取机构失败，请重新登录");
        }
      });
  },
  watch: {
    ifact: function() {
      if (this.ifact) {
        this.isactive = "active";
      } else {
        this.isactive = "";
      }
    }
  },

  methods: {
    //显示优良差
    changeState(v) {
      console.log(v);
      let _this = this;
      this.isture = true;
      setTimeout(function(){
        if (v<100) {
          _this.getSpeed = '差'
        }else if (v < 1000) {
          _this.getSpeed = '良'
        }else {
          _this.getSpeed = '优'
        }
        _this.isture = false;
      },1000)
      
    },
    // 点击获取网速
    getSpeedBtn() {
       this.isture = true
      let gogeSpedd = navigator.connection.downlink * 1024 / 8;
      if(navigator.userAgent.includes("Chrome")) {
         this.isture = false;
         this.changeState(gogeSpedd)
        } else {
            measureBW((speed) => {
               this.changeState(speed)
                this.isture = false
          })
        }
    },
    //跳转到对应的位置
    changePo() {
      let htmlBox = this.$el.querySelector(".drumpPosition");
      this.$nextTick(() => {
        document.documentElement.scrollTop = htmlBox.offsetTop;
      });
    },

    //打开用户设置
    useropen: function() {
      this.ifact = !this.ifact;
      if (this.ifact) {
        this.jigouboxin();
      }
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },

    //登出
    log_out: function() {
      localStorage.tnk = "";
      this.$store.state.editableTabs2 = [];
      setTimeout(() => {
        this.mainshow = false;
      }, 300);
      setTimeout(() => {
        this.leftshow = false;
      }, 500);
      setTimeout(() => {
        this.topshow = false;
      }, 700);
      setTimeout(() => {
        this.$router.push({
          path: "/"
        });
      }, 1000);
    },

    //跳转帆软
    urlgo: function(objects, j, i, titles) {
      let _this = this;
      let istest = API.ISTEST;
      let key = encodeURIComponent(localStorage.tnk);

      let postData_code = _this.$qs.stringify({
      version: API.VERSION_NUM,
      iphone: localStorage.tnk,
      sysid:i
    });
    _this.$axios({
        url: API.API_TOKEN + "PublicUser/UserInfoByIphone",
        method: "POST",
        data: postData_code
      }).then(res => {
        if (res.data.error_code == 0) {
          if (titles == "帆软报表") {
            if (j == 1) {
              // 正式
              $.ajax({
                url: objects + '/WebReport/decision/login/cross/domain',
                data: {'fine_username':localStorage.pe, 'fine_password': localStorage.frmv, 'validity': -1},
                dataType: 'jsonp',
                callback: 'callback',
                success: function (res) {
                  window.open(objects+"/WebReport/decision/");
                }
              })


              // this.$jsonp(objects + '/WebReport/decision/login/cross/domain', {fine_username:localStorage.pe,fine_password:localStorage.frmv,validity: -1,callback:"callback"}).then(json => {
              //   console.log(this.userno);
              //   window.open(objects+"/WebReport/decision/");
              // }).catch(err => {
              // 　　this.$message.error("帆软报表登录异常！！");
              // })
            } else {
              this.$message({
                message: "该系统暂未开通",
                type: "warning"
              });
            }
          } else {
            if (j == 1) {
              console.log(titles);
              console.log(res.data.data[0].isusepos);
              if(titles == "云销售平台" && !res.data.data[0].isusepos){
                this.$message.error("您未使用云销售平台，请联系技术部值班人员！！");
                return false;
              }else{
                window.open(objects + "?lok=" + key + "&systemid=" + i);
              }
            } else {
              this.$message({
                message: "该系统暂未开通",
                type: "warning"
              });
            }
          }
        } else if (res.data.error_code == 40001) {
          _this.$message.error("页面过期，请重新登陆！");
          setTimeout(function() {
            window.parent.location.href = "";
            window.parent.close();
          }, 1000);
        } else {
          _this.$message.error("获取机构失败，请重新登录");
        }
      })

      
    },

    //获取机构下拉数据
    jigouboxin: function() {
      let _this = this;
      let postData_codes = _this.$qs.stringify({
        iphone: localStorage.tnk,
        version: API.VERSION_NUM
      });
      _this
        .$http({
          url: API.API_TOKEN + "Pub_PageJurisdiction/GetUseragenceid",
          method: "POST",
          data: postData_codes
        })
        .then(res => {
          console.log("数据", res);
          if (res.data.error_code == 0) {
            _this.cpTypeAK_return = res.data.data;
            _this.cpTypeAK_sel = parseInt(_this.agenceid);
          } else if (res.data.error_code == 40001) {
            _this.$message.error("页面过期，请重新登陆！");
            setTimeout(function() {
              window.parent.location.href = "";
              window.parent.close();
            }, 1000);
          } else {
            _this.$message.error(res.data.error_message);
          }
        });
    },

    //切换机构确认按钮
    qiejigoubtn: function() {
      let _this = this;
      if (_this.agenceid == _this.cpTypeAK_sel) {
        _this.$message({
          type: "error",
          message: "机构无变化！"
        });
      } else {
        let postData_codes = _this.$qs.stringify({
          iphone: localStorage.tnk,
          agenceid: _this.cpTypeAK_sel,
          version: API.VERSION_NUM
        });
        _this
          .$http({
            url: API.API_TOKEN + "Pub_PageJurisdiction/SetUseragenceid",
            method: "POST",
            data: postData_codes
          })
          .then(res => {
            if (res.data.error_code == 0) {
              localStorage.fzhitype = "";
              localStorage.equitygroupid = "";
              localStorage.tnk = "";
              _this.$message({
                type: "success",
                message: "切换机构成功，请重新登陆！"
              });
              _this.XZDialogVisible = false;
              setTimeout(function() {
                if (API.ISTEST == 1) {
                  window.location.href = "http://users.ailend.hk/#/";
                } else if (API.ISTEST == 2) {
                  window.location.href = "http://member.myailand.cn/#/";
                } else if (API.ISTEST == 3) {
                  window.location.href = "http://webtest.ailend.info:9001/#/";
                }
              }, 1000);
            } else if (res.data.error_code == 40001) {
              _this.$message.error("页面过期，请重新登陆！");
              setTimeout(function() {
                window.parent.location.href = "";
                window.parent.close();
              }, 1000);
            } else {
              _this.$message.error(res.data.error_message);
            }
          });
      }
    },

    //注销用户
    outusers: function() {
      this.$confirm("确定注销用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          localStorage.fzhitype = "";
          localStorage.equitygroupid = "";
          localStorage.tnk = "";
          if (API.ISTEST == 1) {
            window.location.href = "http://users.ailend.hk/#/";
          } else if (API.ISTEST == 2) {
            window.location.href = "http://member.myailand.cn/#/";
          } else if (API.ISTEST == 3) {
            window.location.href = "http://webtest.ailend.info:9001/#/";
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消注销。"
          });
        });
    }
  }
};
</script>
<style scoped>
.wrap {
  width: 100%;
  height: 100%;
  display: block;
}
.main_box {
  transition: transform 0.35s;
  width: 100%;
  height: 100%;
  position: relative;
  /* color: #66b1ff; */
  background: url("../assets/index_banner.png") no-repeat;
  background-size: 100%;
  background-attachment: fixed;
}
.main_box.active {
  transform: translate(-300px, 0px);
}
.content_box {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  padding: 15px 15px 40px 15px;
  /* overflow-y: auto; */
  /* text-align: left; */
}
.minbox_clock {
  width: 1010px;
  height: 350px;
  border: 0px solid red;
}
.minbox1 {
  width: 100%;
  height: 300px;
  border-radius: 5px;
  background-color: #eee;
}
.minbox2 {
  width: 100%;
  height: 350px;
  border-radius: 5px;
  background-color: #eee;
}
.boxicon {
  display: block;
  font-size: 30px;
}
.itembox {
  width: 150px;
  height: 150px;
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  background-color: #fff;
  text-align: center;
  color: #66b1ff;
  padding-top: 35px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
  margin-right: 10px;
}
.itembox:hover {
  box-shadow: 0px 0px 10px #ccc;
}
.itembox i {
  display: block;
  font-size: 30px;
}

.bannerbox {
  width: 100%;
  height: 45%;
  position: relative;
}
.bannertitle {
  width: 500px;
  position: absolute;
  top: 30%;
  left: 50%;
  margin-left: -500px;
}
.bannerbtnbox {
  position: absolute;
  top: 70%;
  left: 50%;
  margin-left: -510px;
}
.bannerbtn {
  margin: 10px 40px;
  padding: 7px 50px;
  border-radius: 30px;
  border: 1px solid #6cadd5;
  color: #fffeff;
  background: none;
  font-size: 18px;
  cursor: pointer;
  outline: none;
}
.bannerbtn.active {
  color: #4ebbd0;
  background: #fff;
}

.context_text {
  width: 1000px;
  margin: 0px auto;
}
.context_title {
  margin: 30px 0;
  text-align: center;
}
.context_itembox {
  width: 100%;
  padding-left: 10px;
  font-size: 0;
}
.itemboxs {
  width: 320px;
  height: 320px;
  margin-right: 10px;
  margin-top: 10px;
  border-radius: 5px;
  box-shadow: 0 0 5px #eee;
  border: 0px solid #4ebbd0;
  transition: all 0.3s;
  text-align: center;
  position: relative;
  display: inline-block;
  font-size: 14px;
  vertical-align: top;
  cursor: pointer;
}
.itemboxs:hover {
  /* border: 1px solid #4EBBD0; */
  box-shadow: 0 0 15px #4ebbd0;
}
.topicon {
  width: 30px;
  height: 25px;
  position: absolute;
  right: 10px;
  top: -1px;
  background: #efefef;
  color: #4ebbd0;
}
.icon-laptop-error {
  color: #ccc;
}
.iconbox {
  width: 120px;
  height: 120px;
  background: url("../assets/index_icon_bg.png") no-repeat;
  background-size: 100%;
  position: absolute;
  top: 40px;
  left: 50%;
  margin-left: -60px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.iconboxicon {
  font-size: 60px;
  color: #4ebbd0;
}
.itembox_title {
  position: absolute;
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  top: 180px;
}
.itembox_note {
  position: absolute;
  width: 100%;
  font-size: 14px;
  text-align: center;
  top: 230px;
  color: #9d9d9d;
  padding: 0px 30px;
}

.usersbox {
  position: absolute;
  top: 20px;
  right: 0px;
  width: 50px;
  height: 30px;
  color: #fff;
  padding-left: 15px;
  cursor: pointer;
}
.usersbox i {
  font-size: 20px;
}
.usersbox.active {
  background-color: #f9f9f9;
  color: #2cade8;
}

.usercog {
  position: absolute;
  top: 0;
  right: 0px;
  width: 300px;
  height: 100%;
  padding: 10px;
  color: #2cade8;
  font-size: 16px;
}
.usercog_title {
  text-align: right;
  padding: 5px;
}
.usercog_content {
  padding: 5px;
}
.usercog_listbox {
  padding: 10px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue